import React from 'react'

export default ({phoneNumber}) => {
    if (phoneNumber) {
        return (
            <a href={`tel:+1${phoneNumber.replace(/\D/g, '')}`}>{phoneNumber}</a>
        )
    }
    return <></>
}